<template>
  <div class="row" v-if="modelValue">
    <div class="col">
      <small
        >Ustvaril: <DisplayEntity v-model="modelValue.userCreatedID" apiEntity="InternalUsers" />;
        {{ $dayjs(modelValue.dateCreated) }}</small
      >
      <small v-show="modelValue.userModifiedID !== '' && modelValue.userModifiedID !== $EMPTY_GUID"
        >&nbsp;Spremenil: <DisplayEntity v-model="modelValue.userModifiedID" apiEntity="InternalUsers" />;
        {{ $dayjs(modelValue.dateModified) }}</small
      >
    </div>
  </div>
</template>

<script>
// moved out of ChangeHistory.js verbatim - options API, there is no setup() to lift
export default {
  name: "ChangeHistory",
  props: {
    modelValue: { type: Object },
  },
}
</script>
